import React from 'react';
import {Box, Typography} from "@material-ui/core";
import ConvertToLatex from "../../../../helper/ConvertToLatex";
import ReactHtmlParser from "react-html-parser";
import ImageWrapper from "./Image";
import FilePDF from "./FilePDF";
import GroupMedia from "./GroupMedia";
import { createMuiTheme, responsiveFontSizes } from '@material-ui/core/styles';
import i18n from 'i18next';
import {red} from "@material-ui/core/colors";
const timeArea = {
    height: 27,
    width: 27,
    textAlign: 'center',
    rounded: true,
    color:'#ffff',
    backgroundColor: '#ED3237',
    paddingTop: 6,
    opacity: 0.8,
    fontSize: '.7rem',
};
const QuestionDescription = ({question, questionIndex}) => {
    return (
        <React.Fragment>
            {question.content.search("latex") !== -1 && !question.hasPdf ?
                <Typography variant="h6">
                    <div className="question-content d-flex">
                        <Box width={30} height={30} border={1} borderRadius="50%" borderColor="primary.main" style={timeArea}>{questionIndex}</Box>
                        {question.content.includes("src=") ?
                            "" : <ConvertToLatex textInput={question.content}/>
                        }
                    </div>
                    {question.content.includes("src=") ?
                        <ConvertToLatex textInput={question.content}/> :""
                    }
                </Typography> : !question.hasPdf ?
                    <Typography
                    variant="h6">
                        <div className="question-content d-flex">
                            <Box width={30} height={30} border={1} borderRadius="50%" borderColor="primary.main" style={timeArea}>{questionIndex}</Box>
                            {question.content.includes("src=") ?
                                "":<Box padding={1} style={{width: '95%'}}> {ReactHtmlParser(question.content)}</Box>
                            }
                        </div>
                        {question.content.includes("src=") ?
                            <Box padding={1}> {ReactHtmlParser(question.content)}</Box> :""
                        }

                </Typography> : <></>}

            <ImageWrapper question={question}/>
            <FilePDF question={question}/>
            <GroupMedia question={question}/>
        </React.Fragment>
    );

};

export default QuestionDescription;
